var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"secondary","text":"","small":"","title":"Imprimir Boleto","rounded":"","icon":_vm.isMobile()},on:{"click":function($event){return _vm.imprimirBoleto()}}},[_c('v-icon',{attrs:{"left":!_vm.isMobile()}},[_vm._v("mdi-barcode")]),(!_vm.isMobile())?_c('span',[_vm._v("Boleto")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }